import styled from 'styled-components';

export const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  font-size: inherit;
  display: inline-flex;
  align-items: center;
  position: relative;

  span {
    transition: opacity ease-in-out 0.2s;
    opacity: ${props => (props.loading ? '0.5' : '1')};
  }

  & > div {
    margin-left: ${props => props.theme.global.gutterSpace * 0.25}px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: ${props => (props.loading ? '1' : '0')};
    transition: opacity ease-in-out 0.2s;
  }
`;
